export default "__VITE_ASSET__ClgRzJfx__"